import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
	IconButton,
	ListItemIcon,
	ListItemText,
	SxProps,
	Theme,
} from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';

export interface HiddenActionItem {
	callback?: () => void;
	icon?: React.ReactNode;
	label?: string;
	component?: React.ReactNode;
	sx?: SxProps<Theme>;
}
interface Props {
	actions: HiddenActionItem[];
	onClickPreventDefault?: boolean;
	isButtonIcon?: boolean;
}

export default function DropdownButton({
	actions,
	onClickPreventDefault,
	isButtonIcon,
}: Props) {
	const [anchorEl, setAnchorEl] = React.useState(null);

	if (!actions || !actions.length) {
		return null;
	} // do not display button if there are no actions

	const handleClick = (event: any) => {
		if (onClickPreventDefault) {
			event.preventDefault();
		}
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleCallback = (callBackFn: () => void) => {
		handleClose();

		if (callBackFn) {
			callBackFn();
		}
	};

	return (
		<>
			{!isButtonIcon ? (
				<Button
					color='primary'
					variant='contained'
					size='medium'
					sx={{ maxWidth: '36px', minWidth: '36px' }}
					onClick={handleClick}
				>
					<MoreHorizIcon />
				</Button>
			) : (
				<IconButton onClick={handleClick}>
					<MoreHorizIcon />
				</IconButton>
			)}
			<Menu
				id='customized-menu'
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={(e: Event) => {
					if (onClickPreventDefault) {
						e.preventDefault();
					}
					handleClose();
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				{actions.map((menuItem, index) => {
					if (menuItem.component) {
						return (
							<MenuItem
								sx={{
									paddingLeft: '0',
									paddingRight: '0',
									...(menuItem.sx ? menuItem.sx : {}),
								}}
								id='menuItem'
								key={index}
								onClick={(e) => {
									if (onClickPreventDefault) {
										e.preventDefault();
									}
									handleCallback(menuItem.callback);
								}}
							>
								{menuItem.component}
							</MenuItem>
						);
					}

					return (
						<MenuItem
							key={index}
							id='menuItem'
							onClick={(e) => {
								if (onClickPreventDefault) {
									e.preventDefault();
								}
								handleCallback(menuItem.callback);
							}}
						>
							{menuItem.icon && <ListItemIcon>{menuItem.icon}</ListItemIcon>}
							<ListItemText>{menuItem.label}</ListItemText>
						</MenuItem>
					);
				})}
			</Menu>
		</>
	);
}
